import { render, staticRenderFns } from "./message-content-contact-request.vue?vue&type=template&id=0bfaad34&scoped=true&"
import script from "./message-content-contact-request.vue?vue&type=script&lang=js&"
export * from "./message-content-contact-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfaad34",
  null
  
)

export default component.exports